import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {api} from "../../api";
import {toastError} from "../admin";
import {ADMIN_LANG} from "../../../settings";

export type PreviewOffCanvasState = {
    url: string;
    isOpen: boolean;
    isLoading: boolean;
}

export const initialState: PreviewOffCanvasState = {
    url: '',
    isOpen: false,
    isLoading: false,
}

export const getPreviewErrorMessage = (code?: string) => {
    if (code === 'preview_empty') {
        return ADMIN_LANG.preview_unavailable;
    }

    if (code === 'preview_stale') {
        return ADMIN_LANG.preview_stale;
    }

    return ADMIN_LANG.preview_failed;
};

export const startPreview = createAsyncThunk(
    'previewOffCanvas/startPreview',
    async (url: string, thunkAPI) => {
        try {
            return await api.post(url, {});
        } catch (error: any) {
            thunkAPI.dispatch(toastError(getPreviewErrorMessage(error.code)));
            return thunkAPI.rejectWithValue({message: error.message, code: error.code});
        }
    }
);

export const slice = createSlice({
    name: 'previewOffCanvas',
    initialState,
    reducers: {
        closePreview: (state) => {
            state.isOpen = false;
            state.url = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(startPreview.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(startPreview.fulfilled, (state, action) => {
                state.isLoading = false;
                state.url = action.payload.preview_url;
                state.isOpen = true;
            })
            .addCase(startPreview.rejected, (state) => {
                state.isLoading = false;
            });
    }
});

export const {closePreview} = slice.actions;
export default slice.reducer;
